import {
  Component,
  OnInit,
  Input, ChangeDetectorRef,
} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ClientMenuComponent} from "../client-menu/client-menu.component";
import {MenuService} from "../../_services/menu-service/menu.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    standalone: false
})
export class LogoComponent implements OnInit {
  @Input() customRouterLink: string[];
  @Input() showMenuIcon = true;

  isOpenMenu = false;
  isAdmin = false;
  constructor(private dialog: MatDialog, private menuService: MenuService, private cdr: ChangeDetectorRef, private router: Router) {}

  ngOnInit(): void {
    this.menuService.menuIsOpen.subscribe(res => {
      this.isOpenMenu = res;
    });
    this.isAdmin = this.router.url.includes('admin');
  }

  openMenu() {
    this.menuService.nextMenuIsOpen(true);
    this.dialog.open(ClientMenuComponent, {
      panelClass: 'menu-dialog-style',
      autoFocus: false,
      height: "100%",
      width: "100%",
      maxWidth: "100%",
      maxHeight: "100%"
    }).afterClosed().subscribe(res => this.cdr.detectChanges());
  }
}
